module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slideDom",
    style: ({
      width: _vm.width,
      height: _vm.slideHeight,
      transform: 'translate3d(' + _vm.offsetX + ',' + _vm.offsetY + ',0)'
    })
  }, [_vm._t("default")], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-1cf09ee6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-1cf09ee6"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/composite/slide/src/slide.vue
// module id = 1058
// module chunks = 1